<template>
  <div class="home-page">
    <div class="header-bgfff bgfff">
      <Header></Header>
      <div class="nav ac">
        <div class="back" @click="back">
          <img width="40" src="../../static/images/back2.png"/>
        </div>
        {{ $t('days_login') }}
      </div>
    </div>

    <div class="home-content">
      <div class="">
        <div class="nav title-bg" style="margin:30px auto 0;">
          <span class="">{{ $t('DailyRewards') }}</span>
        </div>
        <div class="daily-login-list mt20">
          <div class="daily-li" v-for="(item,index) in dailyList"
               :class="{'claimed-sign':item.status==1,'re-sign':item.status==2,'active':item.status==0,'dailyd12':item.status==3,'daily-li2':index==6}"
               @click="getMissed(item)">
            <div class="num">{{ $t('day') }} {{ item.sign_day }}</div>
            <div class="lock2" v-if="item.status==3">
              <img src="../../static/images/lock_2.png">
            </div>
            <div class="img">
              <img :src="item.image"/>
            </div>
            <div class="t">{{ item.title }}</div>
<!--            <div class="Missed disflex" v-if="item.status==2">-->
<!--              <img height="50" src="../../static/images/miss.png">{{ $t('Missed') }}-->
<!--            </div>-->
<!--            <div class="dailyd disflex" v-if="item.status==1">-->
<!--              <img src="../../static/images/dailyd.png">-->
<!--            </div>-->
            <div class="dailyd dailyd2 disflex" v-if="item.status==3"></div>
          </div>
        </div>
        <div class="mt20" style="">
          <button style="width: 50%;height: 100px" class="btn button fw7" @click="getClaim()">
            <span>{{ $t('Claim') }}</span>
          </button>
        </div>
      </div>
    </div>


    <!--补签-->
    <Dialog ref="answerDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
      <div class="invited-c ac" slot="mdBox" style="">
        <div class="invited-l">
          <h2 class="ac mt30 font-family " style="color: #1d188e;font-size: 50px;font-weight: 900"> {{$t('re_sign')}}</h2>
          <div class="level-img-wrapper" style="margin-top: 50px" >
            <img style="width: 50%" src="../../static/images/re-sign-data.png" class="level-img">
          </div>
          <div style="margin-top: 20px;">
            <span  style="color: #1d188e;font-size: 30px">{{$t('DailyLoginT3')}}</span>
          </div>
          <div class="daliy-t">
           " {{info.tip}} "
          </div>
        </div>
        <div class="modal-footer ac" >
          <div class="sig" >
            <button style="font-size: 30px;font-weight: 200" class="btn btn-blue" @click="answerModal()">{{$t('re_sign')}}</button>
          </div>
        </div>
      </div>
    </Dialog>


  </div>

</template>
<script>
import Dialog from '../components/dialog'
import Header from "../components/Header.vue";

export default {
  props: {
    message: {
      type: String,   // 类型校验
      default: '默认值' // 默认值（可选）
    },
  },
  components: {
    Header, Dialog
  },
  data() {
    return {
      info: {},
      dailyList: [],
      parent: null
    }
  },
  created() {
    this.parent = this.$parent
    this.getHome();
  },
  methods: {
    back() {
      this.$router.push({path: '/'})
    },
    answerModal() {
      let that = this;
      that.parent.loadModal(true);
      that.$api.post('/api/sign/buy_sign_card', null, r => {
        if (r.msg) that.$utils.alertText(r.msg);
        that.parent.returnCode(r, function () {
          that.parent.loadModal(false);
          that.getClaim(that.info)
        });

      })
    },
    getMissed(item) {
      if (item.status != 2) {
        if (item.status == 0) {
          this.getClaim()
        } else {
          this.$utils.alertText(item.tips2);
        }
        return;
      }
      this.info = item
      this.$refs.answerDialog.showMaskFun();
    },
    cancelModal() {
      this.$refs.answerDialog.closeMask();
    },
    getHome() {
      let that = this;
      that.parent.loadModal(true);
      that.$api.get('/api/sign/list', null, r => {
        that.parent.returnCode(r, function () {
          that.parent.loadModal(false);
          that.dailyList = r.data
        });

      })
    },
    getClaim(item) {
      let that = this;
      let data = null
      if (item) {
        data = {
          sign_date: item.sign_date,
          is_repair: 1
        }
      }
      that.parent.loadModal(true);
      that.$api.post('/api/sign/signin', data, r => {
        if (r.msg) that.$utils.alertText(r.msg);
        that.parent.returnCode(r, function () {
          that.parent.loadModal(false);
          that.getHome()
          that.$refs.answerDialog.closeMask();
        });

      })
    }
  }
}
</script>
<style>
.title-bg {
  background: url(../../static/images/title-bg.png) no-repeat center 0;
  width: 80%;
  background-size: contain;
  color: #fff;

}

.title-bg span {
  color: #0e0a61;
  font-size: 50px;
  font-weight: 800;
}

.daily-login-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.daily-li {
  width: calc(33.33% - 20px);
  margin: 0 10px 18px;
  background: #00a5ff;
  border-radius: 20px;
  position: relative;
  //border: 3px solid #ffffff00;
  min-height: 250px;
  box-shadow: 0px 10px 10px inset #fff;
}

.daily-li .img {
  text-align: center;
  width: 100%;
  position: relative;
  //margin: 20px 10px 0;
}

.daily-li .img img {
  width: 125px;
  margin-top: 50px;
}

.daily-li .num {
  font-weight: 700;
  font-size: 24px;
  padding: 5px 10px;
  line-height: 24px;
  position: absolute;
  left: 7px;
  top: 5px;
  z-index: 9;
  background: white;
  border: 2px solid #fff;
  border-radius: 30px;
}

.daily-li .t {
  text-align: center;
  color: #ffffff;
  text-shadow: 3px 2px 0 #1f0f00;
  font-size: 25px;
  font-weight: 700;
  position: absolute;
  bottom: 8px;
  letter-spacing: -1px;
  width: 100%;
  border-radius: 0 0 15px 15px;
  z-index: 12;
  line-height: 30px;
}

.lock2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.lock2 img {
  width: 80px;   /* 调整宽度 */
  height: auto;  /* 等比例缩放 */
}

.daily-li2 {
  width: 100%;
  background: #00a5ff;
}

.daily-li2 .img img {
  width: 180px;
}

.daily-li2 .img {
  margin-top: 0;
}

.daily-login {
  padding: 20px 0px 70px;
}

.Missed, .dailyd {
  position: absolute;
  top: 0;
  width: 100%;
  height: calc(100%);
  background: #ff1364;
  border-radius: 20px;
  font-size: 20px;
  justify-content: center;
}

.Missed img {
  vertical-align: middle;
  margin-right: -24px;
}

.daily-li.active {
  border: 3px solid #fff;
  background: #00a5ff;
}

.dailyd {
  background: #94427273;
}

.dailyd2 {
  background: #ffffff00;
}

.dailyd12 .num, .dailyd12 .t {
  opacity: 1;

}

.dailyd img {
  width: 80px;
}

.daliy-t {
  font-size: 30px;
  font-weight: 500;
  background: #fff;
  color: #0e0a61;
  //border: 2px solid #ffde35;
  border-radius: 200px;
  padding: 20px 0;
  //margin-top: -20px;
}

.daily-modal {
}

.big-img {
  width: 450px;
  margin: -20px;
}

.daily-modal2 {
  width: 720px;
  padding: 15px 0px 0;
  margin: 0 auto;
}

.daily-li.dailyd12::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.7); /* 半透明黑 */
  border-radius: 20px;
  z-index: 20;
}

.re-sign {
  background: #ff4c6f;
}

.claimed-sign{
  background: #34e300;
}


</style>



// WEBPACK FOOTER //
// src/page/DailyLogin.vue